import React, { memo, useMemo } from 'react'

import { Block, CRRender, Image, Inline } from '@comp/crRender'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import "./style.css"
import { GetHeaderData } from './AuthContentConst'
const Navbar = () => {

    const { t } = useTranslation()
    const { pathname } = useLocation()
    const { img, caption, title } = useMemo(() => GetHeaderData(), [pathname])

    const isNeedRender = useMemo(() => Boolean(img) || Boolean(caption) || Boolean(title), [img, caption, title])

    console.log(img);
    return (
        <CRRender isRender={isNeedRender}>
            <Image src={img} isRender={img} className={"form-logo"} />
            <CRRender isRender={caption || title}>
                <Inline isRender={caption} className={"caption"}> {t(caption)}</Inline>
                <Block isRender={title} className={"login-title "}> {t(title)}</Block>
            </CRRender>
        </CRRender >

    )
}

export default memo(Navbar)